import React from "react";
import type { planEnrollmentApiSpec } from "@wingspanhq/wingspan-api-types";
import { WSInfoBox } from "@wingspanhq/fe-component-library";
import { OAI_KEY, PGLI_KEY, PLAN_DETAILS } from "../utils/constants";

type IPlanType = planEnrollmentApiSpec.PlanEnrollment["planType"];

const PGLI_CONFIG = PLAN_DETAILS[PGLI_KEY];
const OAI_CONFIG = PLAN_DETAILS[OAI_KEY];

export const FilingAClaim: React.FC<{ planType: IPlanType }> = ({
  planType
}) => {
  const blocks: Record<IPlanType, React.ReactNode> = {
    MeridioHealth: null,
    WingspanOccupationalAccidentInsurance: (
      <>
        If you are injured on the job, file your claim directly with the
        insurer, Intact Insurance.
        <br /> <br />
        <b>Phone:</b>{" "}
        <a
          href={`tel:${OAI_CONFIG.claimsPhone}`}
          target="_blank"
          rel="noreferrer"
        >
          {OAI_CONFIG.claimsPhone}
        </a>{" "}
        <br />
        <b>Online:</b>{" "}
        <a href={OAI_CONFIG.claimsUrl} target="_blank" rel="noreferrer">
          Intact Claims Portal
        </a>{" "}
      </>
    ),
    WingspanProfessionalLiabilityAndGeneralLiabilityInsurance: (
      <>
        If you need to file a claim, you will work directly with the insurer,
        Markel. <br />
        <br />
        <b>Phone</b>:{" "}
        <a
          href={`tel:${PGLI_CONFIG.claimsPhone}`}
          target="_blank"
          rel="noreferrer"
        >
          {PGLI_CONFIG.claimsPhone}
        </a>{" "}
        <br />
        <b>New claims email</b>:{" "}
        <a
          href={`mailto:${PGLI_CONFIG.claimsEmail}`}
          target="_blank"
          rel="noreferrer"
        >
          {PGLI_CONFIG.claimsEmail}
        </a>{" "}
        <br />
      </>
    )
  };

  return blocks[planType] ? (
    <WSInfoBox title="Filing a claim" icon="file">
      {blocks[planType]}
    </WSInfoBox>
  ) : null;
};
